import { render, staticRenderFns } from "./integratedGroupTree.vue?vue&type=template&id=54904405&scoped=true&"
import script from "./integratedGroupTree.vue?vue&type=script&lang=js&"
export * from "./integratedGroupTree.vue?vue&type=script&lang=js&"
import style0 from "./integratedGroupTree.vue?vue&type=style&index=0&id=54904405&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54904405",
  null
  
)

export default component.exports